import { useEffect } from 'react';
import { useFetch } from '@sravni/react-utils';

const useUserNotification = () => {
    const [{ get, data, loading, error }] = useFetch('/proxy-header/notification/');
    useEffect(() => {
        get();
    }, [get]);
    useEffect(() => {
        const listener = () => {
            get();
        };
        window.addEventListener('sravni:user_agreements_changed', listener);
        return () => {
            window.removeEventListener('sravni:user_agreements_changed', listener);
        };
    }, [get]);
    return { loading, data, error };
};

export { useUserNotification };
//# sourceMappingURL=useUserNotification.js.map
